<template>
  <div id="VoteInfoDialog_main">
    <el-dialog
      title="投票資訊"
      :visible.sync="dialogVisible"
      width="40%"
    >
      <el-button
        v-if="data.voteAt && topicStatus != 'decided'"
        type="danger"
        size="small"
        class="cancelButton"
        plain
        @click="cancelVote"
      >
        取消投票
      </el-button>
      <el-form
        label-position="top"
        label-width="80px"
      >
        <div class="group">
          <el-form-item label="戶別">
            {{ data.tabletName }}
          </el-form-item>
          <el-form-item
            label="投票結果"
            :class="classCallback(data.decision)"
          >
            {{ data.decision }}
          </el-form-item>
        </div>
        <div class="dash" />
        <div class="group">
          <el-form-item
            v-if="data.areaThreshold"
            :label="areaPerPerson"
          >
            {{ data.areaThreshold.area }} {{ unit }}
          </el-form-item>
          <el-form-item
            v-if="data.areaThreshold"
            :label="'投票'+ratio"
          >
            {{ areaRatio(data.areaThreshold.areaRatio) }}％
          </el-form-item>
          <el-form-item label="投票時間">
            <span v-if="data.voteAt">{{ $newFormatDate(data.voteAt) }}</span>
            <span v-else>－</span>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer">
        <el-button
          round
          @click="dialogVisible = false"
        >
          關閉
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import tw from '../../utils'
export default {
  data () {
    const { areaPerPerson, ratio, unit } = tw
    return {
      areaPerPerson,
      ratio,
      unit,
      dialogVisible: false,
      id: '', // 區權人id
      data: {}, // 投票資訊內容
      topicStatus: '' // 目前議案狀態，'decided':議案已表決結束，就不開放取消投票button
    }
  },
  methods: {
    openDialog (id, topicStatus) {
      this.dialogVisible = true
      this.id = id
      this.topicStatus = topicStatus
      apiUnitOwnerAssembly.Vote.GetVoteInfo(
        {
          assemblyId: this.$route.params.id,
          topicId: this.$route.params.topicId,
          UnitOwnerId: id
        }
      ).then(res => {
        console.log(res)
        // eslint-disable-next-line eqeqeq
        if (res.status == 200) {
          this.data = res.data
        }
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
        // eslint-disable-next-line eqeqeq
        if (err.response && err.response.status == 400) {
          this.$message.error(err.response.data.description)
          this.dialogVisible = false
        }
      })
    },
    // 詢問取消投票
    cancelVote () {
      this.$confirm('確認取消投票？', '標題', {
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.postCancelVote()
      }).catch(() => {
      })
    },
    // 送出取消投票
    postCancelVote () {
      apiUnitOwnerAssembly.Vote.CancelDecision(
        {
          assemblyId: this.$route.params.id,
          topicId: this.$route.params.topicId,
          unitOwnerId: this.id
        }
      ).then(res => {
        console.log(res)
        // eslint-disable-next-line eqeqeq
        if (res.status == 200) {
          this.$message.success('取消投票成功')
          this.dialogVisible = false
          this.$emit('refresh')
        }
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
        // eslint-disable-next-line eqeqeq
        if (err.response && err.response.status == 400) { this.$message.error(err.response.data.description) }
      })
    },
    areaRatio (areaRatio) {
      if (areaRatio) { return (parseFloat((areaRatio * 100).toPrecision(12))).toFixed(2) }
    },
    classCallback (title) {
      return ['notVoted', 'agreeVote', 'disagreeVote', 'invalidTicket'][['未投票', '同意', '反對', '廢票'].indexOf(title)]
    }
  }
}
</script>
<style lang="sass" scoped>
#VoteInfoDialog_main
  ::v-deep .el-dialog
    +basicDialog
    min-width: 800px
    .el-dialog__body
      position: relative
      .cancelButton
        position: absolute
        top: 24px
        right: 40px
      .el-form
        text-align: left
        .group
          display: flex
          width: 100%
          .el-form-item
            .el-form-item__label
              color: $subFontColor
              flex-shrink: 19px
              line-height: 27px
              padding-bottom: 4px
            .el-form-item__content
              color: $mainFontColor
              font-size: 23px
              line-height: 32px
              font-weight: 600
            &.notVoted
              .el-form-item__content
                color: $mainFontColor
            &.agreeVote
              .el-form-item__content
                color: $mainColor
            &.disagreeVote
              .el-form-item__content
                color: $warnColor
            &.invalidTicket
              .el-form-item__content
                color: $mainFontColor
        .dash
          width: 100%
          height: 1px
          background-image: linear-gradient(to right, $borderDark1 0%, $borderDark1 50%, transparent 50%)
          background-size: 15px 1px
          background-repeat: repeat-x
          margin-bottom: 28px
    .el-dialog__footer
      text-align: center
</style>
